const WIDTH_SP = 768;

(() => {

  // 初期化処理
  const init = () => {
    const body = document.querySelector('body');
    body.style.opacity = 1;

    // 各初期化関数の呼び出し
    initRetina();
    initSmoothScroll();
    initIsOn();
    doFade();
    slider();
    footerBtn();
  };

  // リサイズイベント処理
  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      //xxxxxxxx();
      footerBtn();
    }, 200);
  };

  // スクロールイベント処理
  let lastScrollTime = 0;
  const handleScroll = () => {
    const now = Date.now();
    if (now - lastScrollTime >= 100) {
      doFade();
      initIsOn();
      footerBtn();
      lastScrollTime = now;
    }
  };

  // イベントリスナーの登録
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', handleResize);
  document.addEventListener('scroll', handleScroll);
  
})();

// Retina対応
const initRetina = () => {
  if (window.devicePixelRatio >= 2) {
    document.querySelectorAll('.retina').forEach(img => {
      const retinaSrc = img.getAttribute('src').replace(/\.(?=(?:png|jpg|jpeg)$)/i, '@2x.');
      img.setAttribute('srcset', `${retinaSrc} 2x`);
    });
  }
};

// スムーススクロール
const initSmoothScroll = () => {
  document.querySelectorAll('a[href^="#"]').forEach(trigger => {
    trigger.addEventListener('click', e => {
      e.preventDefault();
      const targetId = trigger.getAttribute('href').replace('#', '');
      const targetElement = document.getElementById(targetId);
      if (targetElement) adjustScrollPosition(targetElement, 'smooth');
    });
  });
};

const adjustScrollPosition = (targetElement, behavior = 'smooth') => {
  const rect = targetElement.getBoundingClientRect().top;
  const offset = window.pageYOffset;
  const gap = document.getElementById('header')?.clientHeight || 0 + 80;
  const target = rect + offset - gap;

  window.scrollTo({ top: target, behavior });
};

// スクロールでis-onクラスを付与
const initIsOn = () => {
  document.querySelectorAll('.js-scroll').forEach(elem => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;

    const isLoad = elem.dataset.load !== undefined;
    const dispPosition = offset - windowHeight;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('is-on');
    }
  });
};

// 要素のフェード
const doFade = () => {
  document.querySelectorAll('.js-fade-in').forEach(elem => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;
    const delay = parseFloat(elem.dataset.delay) || 0;
    const isLoad = elem.dataset.load !== undefined;
    const positionPc = parseFloat(elem.dataset.positionPc) || 200;
    const positionSp = parseFloat(elem.dataset.positionSp) || 0;
    const position = document.body.clientWidth > WIDTH_SP ? positionPc : positionSp;
    const dispPosition = offset - windowHeight + position;
    const duration = parseFloat(elem.dataset.duration) || 1.5;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('js-scroll-in');
      elem.style.transitionDelay = `${delay}s`;
      elem.style.transitionDuration = `${duration}s`;
    }
  });
};

// スライダー
const slider = () => {
  // MV
  const mvSlider = new Swiper('.mv__slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    freeMode: true,
    allowTouchMove: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    autoplay: { delay: 2000 },
    speed: 300,
    loop: true
  });

  // line up
  const updateNavCounter = (swiper) => {
    const total = swiper.slides.length;
    const current = swiper.activeIndex + 1;

    // Swiperの次の要素（.lineup__navigator）を取得
    const navContainer = swiper.el.nextElementSibling;
    
    if (navContainer && navContainer.classList.contains('lineup__navigator')) {
      const navIndex = navContainer.querySelector("#navIndex");
      const navTotal = navContainer.querySelector("#navTotal");
      
      if (navIndex) navIndex.textContent = current;
      if (navTotal) navTotal.textContent = total;
    }
  };

  // line up共通のSwiper設定
  const createLineupSwiper = (container, prevBtn, nextBtn, externalPrevBtn, externalNextBtn) => {
    // 外部ナビゲーション要素を取得
    const externalPrevElement = document.querySelector(externalPrevBtn);
    const externalNextElement = document.querySelector(externalNextBtn);
    
    const swiper = new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 0,
      //autoplay: { delay: 2000 },
      speed: 300,
      loop: false,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      on: {
        init: function () {
          // ナビゲーションカウンターを更新
          updateNavCounter(this);
          if (externalPrevElement && externalNextElement) {
            updateExternalNavState(this, externalPrevElement, externalNextElement);
          }
        },
        slideChange: function () {
          // ナビゲーションカウンターを更新
          updateNavCounter(this);
          if (externalPrevElement && externalNextElement) {
            updateExternalNavState(this, externalPrevElement, externalNextElement);
          }
        },
      },
    });

    // 外部のナビゲーション要素を手動で接続
    if (externalPrevElement) {
      externalPrevElement.addEventListener('click', () => {
        swiper.slidePrev();
      });
    }
    
    if (externalNextElement) {
      externalNextElement.addEventListener('click', () => {
        swiper.slideNext();
      });
    }

    return swiper;
  };

  // line upナビゲーションの状態を更新
  const updateExternalNavState = (swiper, prevBtn, nextBtn) => {
    if (prevBtn) {
      if (swiper.isBeginning) {
        prevBtn.classList.add('swiper-button-disabled');
      } else {
        prevBtn.classList.remove('swiper-button-disabled');
      }
    }
    
    if (nextBtn) {
      if (swiper.isEnd) {
        nextBtn.classList.add('swiper-button-disabled');
      } else {
        nextBtn.classList.remove('swiper-button-disabled');
      }
    }
  };

  // line upSwiperインスタンス
  const linupKitty = createLineupSwiper(
    '.lineup-item-kitty',
    '.lineup-item1-prev1',
    '.lineup-item1-next1',
    '.lineup-item1-prev2',
    '.lineup-item1-next2'
  );

  const lineKuromi = createLineupSwiper(
    '.lineup-item-kuromi',
    '.lineup-item2-prev1',
    '.lineup-item2-next1',
    '.lineup-item2-prev2',
    '.lineup-item2-next2'
  );

  const lineCinnamo = createLineupSwiper(
    '.lineup-item-cinnamo',
    '.lineup-item3-prev1',
    '.lineup-item3-next1',
    '.lineup-item3-prev2',
    '.lineup-item3-next2'
  );

}

// footerのshow/hide
const footerBtn = () => {
  const badge = document.querySelector('.mv__badge');
  const footer = document.querySelector('.footer');
  if (!badge || !footer) return;

  const rect = footer.getBoundingClientRect();
  const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

  if (isVisible) {
    badge.classList.remove('is-show');
  } else {
    badge.classList.add('is-show');
  }
}